module.exports = __webpack_public_path__ + "img/AB5_5290.a22339c0.jpg";